// src/components/DatabaseExplorer/RowDetailsModal.jsx

import React, { useEffect } from "react";
import { FiEye, FiX } from "react-icons/fi";
import {
  getColumnName,
  formatHeader,
  displayValue,
  isPrimaryKey,
} from "./databaseExplorerUtils";

export default function RowDetailsModal({ row, columns, onClose }) {
  useEffect(() => {
    if (!row) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [row, onClose]);

  if (!row) return null;

  return (
    <div
      className="modal d-block"
      role="dialog"
      aria-modal="true"
      aria-labelledby="database-row-details"
      style={{
        backgroundColor: "rgba(15, 23, 42, 0.55)",
        zIndex: 1060,
      }}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div
            className="modal-header text-white"
            style={{
              background: "linear-gradient(110deg, #063b87, #087344)",
            }}
          >
            <h5 className="modal-title fw-bold" id="database-row-details">
              <FiEye className="me-2" />
              Record details
            </h5>

            <button
              type="button"
              className="btn text-white"
              onClick={onClose}
              aria-label="Close modal"
            >
              <FiX size={22} />
            </button>
          </div>

          <div className="modal-body p-3 p-md-4">
            <div className="row g-3">
              {columns.map((column) => {
                const name = getColumnName(column);

                return (
                  <div className="col-12 col-md-6" key={name}>
                    <div className="border rounded-3 p-3 h-100 bg-light">
                      <div className="small text-secondary mb-2">
                        {formatHeader(name)}

                        {isPrimaryKey(column) && (
                          <span className="badge text-bg-primary ms-2">PK</span>
                        )}
                      </div>

                      <div
                        className="fw-semibold text-break"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {displayValue(row[name])}
                      </div>

                      <div className="small text-secondary mt-2">
                        {column.Type || column.type || ""}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <details className="mt-4">
              <summary
                className="text-primary small"
                style={{ cursor: "pointer" }}
              >
                View raw JSON
              </summary>

              <pre
                className="bg-light border rounded p-3 mt-2 small"
                style={{
                  whiteSpace: "pre-wrap",
                  overflowWrap: "anywhere",
                }}
              >
                {JSON.stringify(row, null, 2)}
              </pre>
            </details>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
